module.exports = __webpack_public_path__ + "static/ip-ikon5-e76ee458683dd6fd0a37f0da1fa5423f.png";